import type { MenuItems } from "./menu.type";

import { useLocation } from "react-router";

import { getMenuItemsSelectedKeys } from "./menu.helper";

export const useMenuSelectedKeys = (menuItems: MenuItems) => {
  const { pathname, search } = useLocation();

  return {
    selectedKeys: getMenuItemsSelectedKeys({ menuItems, pathname, search }),
  };
};
